import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'; // The redux-toolkit provider
import { store } from './beat/redux/store'; // the individual h2o webgis store
import { App } from './App';
import './index.scss';
import { enableMapSet } from "immer"
import { OpenMapOptions } from './beat/interfaces';
import { setIsDisplayed } from './beat/redux/slice/mapSlice';
enableMapSet()


   const root = createRoot(document.getElementById('beat-webgis')!);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App     />
      </Provider>
    </React.StrictMode>
  );



 








